export default {
  name: 'marking--deliveryType',
};